import { EmployeeTypeCategoryID, ListItemDto } from "Api/Api";
import { EmployeeFormData } from "Components/HumanResources/Employees/EmployeeEdit/EmployeeEditForm";
import { Autocomplete } from "Components/Shared/Inputs/Autocomplete";
import * as React from "react";
import { UseFormMethods } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { getHumanResourcesEmployeeAutocompleteAsync } from "State/HumanResources/HumanResourcesReducer";
import { RootStateType } from "State/Store";
import styled from "styled-components";
import { nameof } from "Utils/ObjectUtils";

type Props = {
  form: UseFormMethods<EmployeeFormData>;
  label: string;
};

const StyledWrapper = styled.div``;

const emptyListItem: ListItemDto = {
  itemID: 0,
  name: "",
};

export const EmployeeEditSupervisor: React.FunctionComponent<Props> = props => {
  const dispatch = useDispatch();
  const { setValue, register, watch } = props.form;
  const { supervisorID, supervisorFirstName, supervisorLastName } = watch();

  const [supervisor, setSupervisor] = React.useState<ListItemDto>(
    emptyListItem,
  );

  React.useEffect(() => {
    setSupervisor({
      itemID: supervisorID ?? 0,
      name: `${supervisorFirstName ?? ""} ${supervisorLastName ?? ""}`.trim(),
    });
  }, [supervisorID, supervisorFirstName, supervisorLastName]);

  React.useEffect(() => {
    register({ name: nameof<EmployeeFormData>("supervisorID") });
    register({ name: nameof<EmployeeFormData>("supervisorFirstName") });
    register({ name: nameof<EmployeeFormData>("supervisorLastName") });
  }, [register]);

  const {
    employeesAutocompleteList,
    isEmployeesAutocompleteLoading,
  } = useSelector((e: RootStateType) => e.humanResources);

  const onSearch = (text: string) => {
    dispatch(
      getHumanResourcesEmployeeAutocompleteAsync.request({
        search: text,
        employeeTypeCategoryIDs: [
          EmployeeTypeCategoryID.Internal,
          EmployeeTypeCategoryID.External,
        ],
      }),
    );
  };

  const handleChange = (val: ListItemDto | null) => {
    setValue(nameof<EmployeeFormData>("supervisorID"), val?.itemID);
    setValue(nameof<EmployeeFormData>("supervisorFirstName"), val?.name ?? "");
    setValue(nameof<EmployeeFormData>("supervisorLastName"), "");
    setSupervisor(val ?? emptyListItem);
  };

  return (
    <StyledWrapper className={"supervisor"}>
      <div>
        <Autocomplete
          value={supervisor}
          onSearch={onSearch}
          isLoading={isEmployeesAutocompleteLoading}
          options={(employeesAutocompleteList ?? []).map(e => {
            return {
              itemID: e.employeeID,
              name: e.name,
            };
          })}
          onChange={handleChange}
          label={props.label}
        />
      </div>
      <div></div>
    </StyledWrapper>
  );
};
